'use client'

import { HtmlType } from '../../../Homepage/_components/types'

type THtmlProps = {
  blockData: HtmlType
}

/**
 * 渲染纯 html 内容
 */
const Html = ({ blockData }: THtmlProps) => {
  if (!blockData.content) {
    return null
  }

  return <div className="w-full" dangerouslySetInnerHTML={{ __html: blockData.content }} />
}

export default Html
